import { render } from "./TestimonialsCarrousel.vue?vue&type=template&id=49f9d588&scoped=true"
import script from "./TestimonialsCarrousel.vue?vue&type=script&lang=js"
export * from "./TestimonialsCarrousel.vue?vue&type=script&lang=js"

import "./TestimonialsCarrousel.vue?vue&type=style&index=0&id=49f9d588&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f9d588"]])

export default __exports__